/**
 * Polls for a property to appear on the window object
 * @param {string} propertyPath - Dot notation path to the property (e.g. 'foo.bar')
 * @param {Object} options - Configuration options
 * @param {number} [options.interval=100] - Polling interval in milliseconds
 * @param {number} [options.timeout=5000] - Maximum time to wait in milliseconds
 * @returns {Promise<any>} - Resolves with the property value when found
 */
export function pollForWindowProperty(propertyPath: string, options: { interval?: number; timeout?: number } = {}) {
  const { interval = 100, timeout = 5000 } = options;

  const startTime = Date.now();

  return new Promise((resolve, reject) => {
    const checkProperty = () => {
      // Get the nested property using reduce
      const value = propertyPath.split('.').reduce<any>((obj, key) => {
        return obj?.[key as keyof typeof obj];
      }, window);

      // Check for truthy value, not just !== undefined
      // This prevents accepting null as a valid placeholder
      if (value) {
        resolve(value);
        return;
      }

      if (Date.now() - startTime >= timeout) {
        reject(new Error(`Timeout waiting for window.${propertyPath}`));
        return;
      }

      setTimeout(checkProperty, interval);
    };

    checkProperty();
  });
}
